import * as React from 'react';

import {Description} from 'shells/entity/entity-display-values/description';

import styles from './cell.module.css';

type Props = {
    value:
        | {
              value: string;
              description: string;
          }
        | null
        | undefined;
};

export function CellDescription(props: Props) {
    if (!props.value) {
        return null;
    }

    return (
        <div title={props.value.description} className={styles['cell-content']}>
            <Description value={props.value} />
        </div>
    );
}
